export enum PolicyQueryKeys {
  CompanyList = 'companyList'
}
